
// import { Children } from 'react';
import './styles.css'
const BCButom = ({className='btnOne', name=null, onClick, id=null, children='دکمه', style=null}) => {
    return <button style={style} className={className} name={name} onClick={onClick} id={id}>{children}</button>
}
export default BCButom;